require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-impersonation-fraud-alert.json") })
        }
      }, "path---es-articles-impersonation-fraud-alert");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-impersonation-fraud-alert!./.cache/json/es-articles-impersonation-fraud-alert.json
// module id = 2209
// module chunks = 231608221292675